(function () {
  var PRODUCT_WIDGET_SELECTOR = '[data-townwine-collector-stats]';
  var SUMMARY_WIDGET_SELECTOR = '[data-townwine-collector-summary]';
  var DEFAULT_PROXY_BASE = '/apps/townwine-follow';
  var followRefreshTimer = null;
  var snapshotRequestCache = new Map();
  var SNAPSHOT_RETRY_LIMIT = 2;
  var PENDING_FOLLOW_EVENT_TTL_MS = 5000;
  var pendingOptimisticFollowEvents = new Map();

  function normalizeProxyBase(value) {
    var trimmedValue = String(value || '').trim();

    if (!trimmedValue) {
      return DEFAULT_PROXY_BASE;
    }

    return trimmedValue.endsWith('/') ? trimmedValue.slice(0, -1) : trimmedValue;
  }

  function normalizeHandle(value) {
    return String(value || '')
      .trim()
      .replace(/^@+/, '')
      .replace(/\/+$/, '')
      .toLowerCase();
  }

  function getRequestShop() {
    var shop = '';

    if (window.Shopify && typeof window.Shopify.shop === 'string') {
      shop = window.Shopify.shop;
    }

    return String(shop || '').trim().toLowerCase();
  }

  function getProductWidgets(root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(PRODUCT_WIDGET_SELECTOR));
  }

  function getSummaryWidgets(root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(SUMMARY_WIDGET_SELECTOR));
  }

  function getSummaryWidgetMatchHandles(widget) {
    var aliases = [];
    var extraHandles = String(widget.dataset.collectorMatchHandles || '')
      .split(',')
      .map(normalizeHandle)
      .filter(Boolean);
    var primaryHandle = normalizeHandle(widget.dataset.influencerHandle || '');

    [primaryHandle]
      .concat(extraHandles)
      .forEach(function (value) {
        if (value && aliases.indexOf(value) === -1) {
          aliases.push(value);
        }
      });

    return aliases;
  }

  function collectGroups(root) {
    var groups = new Map();

    getProductWidgets(root || document).forEach(function (widget) {
      if (!(widget instanceof HTMLElement)) {
        return;
      }

      var productId = String(widget.dataset.productId || '').trim();

      if (!productId) {
        return;
      }

      var proxyBase = normalizeProxyBase(widget.dataset.proxyBase);
      var group = groups.get(proxyBase) || {
        productWidgets: [],
        summaryWidgets: [],
        productIds: new Set(),
        handles: new Set(),
      };

      group.productWidgets.push(widget);
      group.productIds.add(productId);
      groups.set(proxyBase, group);
    });

    getSummaryWidgets(root || document).forEach(function (widget) {
      if (!(widget instanceof HTMLElement)) {
        return;
      }

      var handles = getSummaryWidgetMatchHandles(widget);

      if (!handles.length) {
        return;
      }

      var proxyBase = normalizeProxyBase(widget.dataset.proxyBase);
      var group = groups.get(proxyBase) || {
        productWidgets: [],
        summaryWidgets: [],
        productIds: new Set(),
        handles: new Set(),
      };

      group.summaryWidgets.push(widget);
      handles.forEach(function (handle) {
        group.handles.add(handle);
      });
      groups.set(proxyBase, group);
    });

    return groups;
  }

  function setText(scope, selector, value) {
    scope.querySelectorAll(selector).forEach(function (element) {
      if (element instanceof HTMLElement) {
        element.textContent = value;
      }
    });
  }

  function formatInteger(value) {
    var safeValue = Number(value);

    if (!Number.isFinite(safeValue)) {
      return '0';
    }

    return new Intl.NumberFormat('ko-KR').format(Math.max(0, Math.trunc(safeValue)));
  }

  function formatFollowerCount(value) {
    var safeValue = Number(value);

    if (!Number.isFinite(safeValue)) {
      return '0 팔로워';
    }

    safeValue = Math.max(0, Math.trunc(safeValue));

    if (safeValue >= 1000) {
      return (safeValue / 1000).toFixed(1).replace(/\.0$/, '') + 'k 팔로워';
    }

    return formatInteger(safeValue) + ' 팔로워';
  }

  function toCount(value) {
    var parsedValue = Number(String(value == null ? '' : value).trim());

    if (!Number.isFinite(parsedValue)) {
      return null;
    }

    return Math.max(0, Math.trunc(parsedValue));
  }

  function toCountFromLabel(value) {
    var rawValue = String(value == null ? '' : value).trim().toLowerCase();

    if (!rawValue) {
      return null;
    }

    var compactMatch = rawValue.match(/(\d+(?:\.\d+)?)\s*k\b/);
    if (compactMatch) {
      var compactValue = Number(compactMatch[1]);

      if (Number.isFinite(compactValue)) {
        return Math.max(0, Math.trunc(compactValue * 1000));
      }
    }

    var digitMatches = rawValue.match(/\d+/g);
    if (!digitMatches || !digitMatches.length) {
      return null;
    }

    var parsedValue = Number(digitMatches.join(''));

    if (!Number.isFinite(parsedValue)) {
      return null;
    }

    return Math.max(0, Math.trunc(parsedValue));
  }

  function wait(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function getDealsLabel(widget, snapshot) {
    if (!(widget instanceof HTMLElement) || !snapshot) {
      return '누적 공구 0회';
    }

    var dealsFormat = String(widget.dataset.dealsFormat || '').trim();

    if (dealsFormat) {
      return dealsFormat.replace('{count}', formatInteger(snapshot.dealCount || 0));
    }

    return snapshot.dealsLabel || '누적 공구 0회';
  }

  function setLoadingState(widget) {
    if (!(widget instanceof HTMLElement) || widget.dataset.statsReady === 'true') {
      return;
    }

    setText(widget, '[data-collector-followers]', widget.dataset.loadingFollowersLabel || '집계 중');
    setText(widget, '[data-collector-deals]', widget.dataset.loadingDealsLabel || '집계 중');
  }

  function applySnapshot(widget, snapshot) {
    if (!(widget instanceof HTMLElement) || !snapshot) {
      return;
    }

    widget.dataset.followerCount = String(snapshot.followerCount || 0);
    widget.dataset.dealCount = String(snapshot.dealCount || 0);
    widget.dataset.liveDealCount = String(snapshot.liveDealCount || 0);
    widget.dataset.upcomingDealCount = String(snapshot.upcomingDealCount || 0);
    widget.dataset.statsReady = 'true';

    var collectorCard = widget.closest('[data-collector-card]');
    if (collectorCard instanceof HTMLElement) {
      collectorCard.dataset.followerCount = String(snapshot.followerCount || 0);
      collectorCard.dataset.dealCount = String(snapshot.dealCount || 0);
      collectorCard.dataset.liveDealCount = String(snapshot.liveDealCount || 0);
      collectorCard.dataset.upcomingDealCount = String(snapshot.upcomingDealCount || 0);

      setText(collectorCard, '[data-collector-live-deals]', formatInteger(snapshot.liveDealCount || 0));
      setText(
        collectorCard,
        '[data-collector-upcoming-deals]',
        formatInteger(snapshot.upcomingDealCount || 0),
      );
    }

    setText(widget, '[data-collector-followers]', snapshot.followersLabel || '0 팔로워');
    setText(widget, '[data-collector-deals]', getDealsLabel(widget, snapshot));
    setText(widget, '[data-collector-live-deals]', formatInteger(snapshot.liveDealCount || 0));
    setText(widget, '[data-collector-upcoming-deals]', formatInteger(snapshot.upcomingDealCount || 0));
  }

  function buildSnapshotRequestKey(proxyBase, productIds, handles) {
    return [
      proxyBase,
      getRequestShop(),
      productIds.slice().sort().join(','),
      handles.slice().sort().join(','),
    ].join('::');
  }

  function requestSnapshots(url, attempt) {
    return fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    }).then(function (response) {
      if (!response.ok) {
        if (attempt < SNAPSHOT_RETRY_LIMIT) {
          return wait(250 * (attempt + 1)).then(function () {
            return requestSnapshots(url, attempt + 1);
          });
        }

        throw new Error('COLLECTOR_STATS_REQUEST_FAILED');
      }

      return response.json();
    });
  }

  function fetchSnapshots(proxyBase, productIds, handles) {
    var url = new URL(proxyBase + '/collector-stats', window.location.origin);
    var requestKey = buildSnapshotRequestKey(proxyBase, productIds, handles);
    var requestShop = getRequestShop();

    productIds.forEach(function (productId) {
      url.searchParams.append('productId', productId);
    });

    handles.forEach(function (handle) {
      url.searchParams.append('handle', handle);
    });

    if (requestShop) {
      url.searchParams.set('shop', requestShop);
    }

    if (snapshotRequestCache.has(requestKey)) {
      return snapshotRequestCache.get(requestKey);
    }

    var requestPromise = requestSnapshots(url.toString(), 0).finally(function () {
      snapshotRequestCache.delete(requestKey);
    });

    snapshotRequestCache.set(requestKey, requestPromise);

    return requestPromise;
  }

  function getEventMatchHandles(detail) {
    var aliases = [];
    var matchHandles = detail && detail.matchHandles;
    var values = [];

    if (Array.isArray(matchHandles)) {
      values = matchHandles;
    } else if (typeof matchHandles === 'string') {
      values = matchHandles.split(',');
    }

    [detail && detail.influencerHandle]
      .concat(values)
      .map(normalizeHandle)
      .filter(Boolean)
      .forEach(function (value) {
        if (aliases.indexOf(value) === -1) {
          aliases.push(value);
        }
      });

    return aliases;
  }

  function getFollowEventKey(detail) {
    if (!detail) {
      return '';
    }

    var handles = getEventMatchHandles(detail);
    var primaryHandle = normalizeHandle((detail && detail.influencerHandle) || '');
    var eventHandle = primaryHandle || (handles[0] || '');
    var proxyBase = normalizeProxyBase((detail && detail.proxyBase) || DEFAULT_PROXY_BASE);
    var followingState =
      detail && typeof detail.following === 'boolean' ? String(detail.following) : '';

    if (!eventHandle || !followingState) {
      return '';
    }

    return [proxyBase, eventHandle, followingState].join('::');
  }

  function prunePendingOptimisticFollowEvents(now) {
    pendingOptimisticFollowEvents.forEach(function (timestamp, key) {
      if (now - timestamp > PENDING_FOLLOW_EVENT_TTL_MS) {
        pendingOptimisticFollowEvents.delete(key);
      }
    });
  }

  function rememberPendingOptimisticFollowEvent(detail) {
    var eventKey = getFollowEventKey(detail);

    if (!eventKey) {
      return;
    }

    var now = Date.now();
    prunePendingOptimisticFollowEvents(now);
    pendingOptimisticFollowEvents.set(eventKey, now);
  }

  function consumePendingOptimisticFollowEvent(detail) {
    var eventKey = getFollowEventKey(detail);

    if (!eventKey || !pendingOptimisticFollowEvents.has(eventKey)) {
      return false;
    }

    var now = Date.now();
    var timestamp = pendingOptimisticFollowEvents.get(eventKey) || 0;
    pendingOptimisticFollowEvents.delete(eventKey);

    return now - timestamp <= PENDING_FOLLOW_EVENT_TTL_MS;
  }

  function clearInversePendingOptimisticFollowEvent(detail) {
    if (!detail || typeof detail.following !== 'boolean') {
      return;
    }

    var eventKey = getFollowEventKey({
      proxyBase: detail.proxyBase,
      influencerHandle: detail.influencerHandle,
      matchHandles: detail.matchHandles,
      following: !detail.following,
    });

    if (eventKey) {
      pendingOptimisticFollowEvents.delete(eventKey);
    }
  }

  function getSnapshotScore(snapshot) {
    if (!snapshot) {
      return -1;
    }

    return (
      Math.max(0, Number(snapshot.dealCount || 0)) * 1000000 +
      Math.max(0, Number(snapshot.followerCount || 0))
    );
  }

  function getPreferredSummarySnapshot(widget, snapshots) {
    var handles = getSummaryWidgetMatchHandles(widget);
    var bestSnapshot = null;
    var bestScore = -1;

    handles.forEach(function (handle) {
      var snapshot = snapshots[handle];

      if (!snapshot) {
        return;
      }

      var score = getSnapshotScore(snapshot);

      if (score > bestScore) {
        bestSnapshot = snapshot;
        bestScore = score;
      }
    });

    if (bestSnapshot) {
      return bestSnapshot;
    }

    return snapshots[normalizeHandle(widget.dataset.influencerHandle || '')] || null;
  }

  function applyOptimisticFollowChange(detail) {
    if (!detail || typeof detail.following !== 'boolean') {
      return;
    }

    var delta = detail.following ? 1 : -1;
    var matchHandles = getEventMatchHandles(detail);

    if (!matchHandles.length) {
      return;
    }

    getSummaryWidgets(document).forEach(function (widget) {
      if (!(widget instanceof HTMLElement)) {
        return;
      }

      var widgetHandles = getSummaryWidgetMatchHandles(widget);
      var isMatched = widgetHandles.some(function (handle) {
        return matchHandles.indexOf(handle) !== -1;
      });

      if (!isMatched || widget.dataset.statsReady !== 'true') {
        return;
      }

      var currentFollowerCount = toCount(widget.dataset.followerCount);
      var currentDealCount = toCount(widget.dataset.dealCount);
      var currentLiveDealCount = toCount(widget.dataset.liveDealCount);
      var currentUpcomingDealCount = toCount(widget.dataset.upcomingDealCount);

      if (currentFollowerCount == null) {
        var followerNode = widget.querySelector('[data-collector-followers]');
        currentFollowerCount = toCountFromLabel(
          followerNode && typeof followerNode.textContent === 'string'
            ? followerNode.textContent
            : '',
        );
      }

      if (currentDealCount == null) {
        var dealNode = widget.querySelector('[data-collector-deals]');
        currentDealCount = toCountFromLabel(
          dealNode && typeof dealNode.textContent === 'string' ? dealNode.textContent : '',
        );
      }

      if (currentFollowerCount == null || currentDealCount == null) {
        return;
      }

      var nextFollowerCount = Math.max(0, currentFollowerCount + delta);

      applySnapshot(widget, {
        followerCount: nextFollowerCount,
        dealCount: currentDealCount,
        liveDealCount: currentLiveDealCount == null ? 0 : currentLiveDealCount,
        upcomingDealCount: currentUpcomingDealCount == null ? 0 : currentUpcomingDealCount,
        followersLabel: formatFollowerCount(nextFollowerCount),
        dealsLabel: '누적 공구 ' + formatInteger(currentDealCount) + '회',
      });
    });
  }

  function refresh(root) {
    var groups = collectGroups(root || document);

    groups.forEach(function (group, proxyBase) {
      var productIds = Array.from(group.productIds);
      var handles = Array.from(group.handles);

      if (!productIds.length && !handles.length) {
        return;
      }

      group.productWidgets.forEach(setLoadingState);
      group.summaryWidgets.forEach(setLoadingState);

      fetchSnapshots(proxyBase, productIds, handles)
        .then(function (payload) {
          var snapshots = (payload && payload.snapshots) || {};

          group.productWidgets.forEach(function (widget) {
            if (!(widget instanceof HTMLElement)) {
              return;
            }

            var productId = String(widget.dataset.productId || '').trim();
            applySnapshot(widget, snapshots[productId]);
          });

          group.summaryWidgets.forEach(function (widget) {
            if (!(widget instanceof HTMLElement)) {
              return;
            }

            applySnapshot(widget, getPreferredSummarySnapshot(widget, snapshots));
          });

          document.dispatchEvent(
            new CustomEvent('townwine:collector-stats-updated', {
              detail: {
                proxyBase: proxyBase,
              },
            }),
          );
        })
        .catch(function (error) {
          console.warn('[collector-stats] failed to fetch snapshots', error);
        });
    });
  }

  function initialize(root) {
    refresh(root || document);
  }

  function scheduleFollowRefresh() {
    if (followRefreshTimer) {
      window.clearTimeout(followRefreshTimer);
    }

    followRefreshTimer = window.setTimeout(function () {
      followRefreshTimer = null;
      refresh(document);
    }, 1200);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  document.addEventListener('townwine:follow-change', function (event) {
    var detail = (event && event.detail) || null;
    var phase = String((detail && detail.phase) || '').trim().toLowerCase();

    if (phase === 'optimistic') {
      rememberPendingOptimisticFollowEvent(detail);
      applyOptimisticFollowChange(detail);
      scheduleFollowRefresh();
      return;
    }

    if (phase === 'rollback') {
      clearInversePendingOptimisticFollowEvent(detail);
      applyOptimisticFollowChange(detail);
      scheduleFollowRefresh();
      return;
    }

    if (!consumePendingOptimisticFollowEvent(detail)) {
      applyOptimisticFollowChange(detail);
    }

    scheduleFollowRefresh();
  });

  window.TownWineCollectorStats = {
    init: initialize,
    refresh: refresh,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
    return;
  }

  initialize(document);
})();
